export default __webpack_public_path__ + "static/0257-125c6e1d8292e627314aeaef1b9870e4.png";